import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { debounce as _debounce } from 'es-toolkit';
import { random as _random } from 'es-toolkit';
// import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
// import { LiquidGlass } from '@ybouane/liquidglass';
// register plugins
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger); //, DrawSVGPlugin);

export default class EFFEX {

	constructor(options) {

		this.defaults = {
			debug: false,
			duration_logo_anim: 2000, // pixels

			optimizeMobile: true
		}
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = 'effx';


		this.window = window;
		this.document = document;
		this.htmlEl = document.documentElement;
		this.body = document.body;

		this.main = this.options.main;

		this.resize_timeout = null;
		this.ids = [];

		this.mousePos = { x:0, y:0 };

	}

	init( firstTime=false ) {


		//console.log( "EFFEX init", fistTime );

		this.addEvents(true);
		// this.initLogoHomeAnimation();
		// this.initDesktopHeaderSticky();
		// clearTimeout( this.id_timeout_overlap );
		// this.checkMainWhenOverlapHeader();
		// this.id_timeout_overlap = setTimeout( ()=>this.checkMainWhenOverlapHeader(), 100 );
		// this.animateBackgroundGradient();
		this.initEffectParallaxBackgroundImages();
		clearTimeout( this.id_timeout_images );
		this.id_timeout_images = setTimeout( ()=>this.checkImagesInView(), 0 );
		clearTimeout( this.id_timeout_scroll_text );
		this.id_timeout_scroll_text = setTimeout( ()=>this.initScrollText(), 300 ); // wait for slideshow to be initialized to calculate correctly the heights
		// clearTimeout( this.id_timeout_mobile_header );
		// this.id_timeout_mobile_header = setTimeout( ()=>this.initMobileTabletHeaderHide(), 17 );

		//setTimeout( ()=>this.moveFooter( true ), 377 );

		//this.setNavigationState();
		//this.lockTimelineSidebar();
		//this.lockShareButtons();

		/*
		this.initScrollColsAtDifferentSpeed();
		*/

		//this.initParallax();
		//this.initParallaxWorks();
		//this.initEffectParallaxImage();
		this.initEffectParallaxImageSmoothTravelling();
		this.initEffectParallaxBeforeAfter();

		// Page Specific effects
		clearTimeout( this.id_header_injects );
		this.id_header_injects = setTimeout( ()=>{
			this.initProjectsCategoriesOnHeaderWhenScrolling( true );
			this.initProjectSingleShowTitleOnHeaderWhenScrolling( true );
		}, 200 );


		this.initHeaderHide();

		/*
		//------------------- desktop ---------------------//
		this.initNavCompact();
		this.setBurgerPin();

		//------------------- mobile ---------------------//
		this.setMobileHeaderPin();

		setTimeout( ()=>this.setBurgerMobilePin(), 0);

		this.setMenuSubPagesMobilePin();
		this.initMobileSubmenuPages();
		this.initSubmenuPages();

		this.initSubmenuSticky();
		setTimeout( ()=>this.checkView(), 277 );

		this.initModuleHortFiltersSticky();
		*/

		/*
		if ( this.body.classList.contains( 'home' ) ){
			this.randomizeGradientHover( true );
		}
		*/

		// this.initScrollDownArrow();

		if ( firstTime ){
			//this.initHeaderLiquidGlass()

			this.initRecordMouseMovePosition();
		}

	}

	/*
	initHeaderLiquidGlass(){
		const glassEls = [];
		let h = document.getElementById('header');

		h.dataset.config = JSON.stringify({
			blurAmount: 0.3,
			chromAberration: 0.2,
			cornerRadius: 60,
			zRadius: 60,
			refraction: 1.2,
			brightness: -0.2,
		});

		glassEls.push( h );

		async function linit( glassEls ){
			return await LiquidGlass.init({
				root: document.getElementById( 'main' ),
				glassElements: glassEls,
			});
		}

		const instance = linit( glassEls );

	}
	*/


	reset() {
		clearTimeout( this.resize_timeout );
		this.destroy();
		this.resize_timeout = setTimeout( ()=>this.init(), 27 );
	}

	//------------------------------------------ UTILS -----------------------------------------//
	addEvents(b) {
		if (b) {
			this.r = _debounce(() => { this.onResize() }, 60 );
			window.addEventListener('resize', this.r);
		}
		else {
			if (this.r) {
				this.r.cancel && this.r.cancel();
				window.removeEventListener('resize', this.r);
			}
		}
	}

	onResize() {
		this.reset()
	}

	getWindowHeight() {
		return window.innerHeight || this.document.documentElement.clientHeight;
	}
	getDocHeight() {
		const d = this.document;
		return Math.max(
			d.body.scrollHeight, d.documentElement.scrollHeight,
			d.body.offsetHeight, d.documentElement.offsetHeight,
			d.documentElement.clientHeight
		);
	}




	//------------------------------------------ EFFECTS -----------------------------------------//
	initProjectSingleShowTitleOnHeaderWhenScrolling( b ){
		if ( !this.body.classList.contains( 'single-project' ) ) return;
		const el = document.querySelector( '#header .project-title' ),
			  title = document.querySelector( 'h1.hero-title' );
		//if ( !el || !title ) return;

		if ( !b ){
			el.innerHTML = '';
			return;
		}
		el.innerHTML = '/ ' + title.innerHTML;
		ScrollTrigger.create({
			trigger: title,
			start: 'bottom top',
			scrub: false,
			markers: false,
			id: this.getID(),
			onEnter: self => {
				this.body.classList.add( 'show-header-project-title' );
			},
			onEnterBack: self => {
				this.body.classList.remove( 'show-header-project-title' );
			}
		});
	}

	initProjectsCategoriesOnHeaderWhenScrolling( b ){
		if ( ! (this.body.classList.contains( 'page-template-projects' ) || this.body.classList.contains( 'tax-project-category' ) ) ) return;
		const el = document.querySelector( '#header .project-title' ),
			  menu = document.querySelector( '.menu-categories .menu' );
		//if ( !el || !title ) return;

		if ( !b ){
			el.innerHTML = '';
			return;
		}

		el.innerHTML = '<ul class="menu project-categories">' + menu.innerHTML + '</ul>';
		ScrollTrigger.create({
			trigger: menu,
			start: 'bottom top',
			scrub: false,
			markers: false,
			id: this.getID(),
			onEnter: self => {
				this.body.classList.add( 'show-header-project-title' );
			},
			onEnterBack: self => {
				this.body.classList.remove( 'show-header-project-title' );
			}
		});
	}


	/*
	initDesktopHeaderStickyBackUp(){
		const el = document.querySelector('.header-desktop');

		//console.log( el );

		if (!el) return;

		const int = el.querySelector( '.layout' );
		const logo = el.querySelector( '.logo' );

		if ( this.body.classList.contains( 'home' ) ){
			gsap.set( int, {height: 280 } );
			gsap.set( logo, {width:'100%'} );
		}
		else{
			gsap.set( int, { height: 64} );
			gsap.set( logo, {width:'280'} );
		}

		const l = this.getDocHeight() - this.getWindowHeight();

		ScrollTrigger.create({
			trigger: el,
			start: "top top",
			pin: el,
			pinSpacing: false,
			//end: l, //() => { return this.getDocHeight() - this.getWindowHeight(); },
			endTrigger: document.querySelector('#footer'),
			end: "top top",
			scrub: true,
			markers: false,
			id: this.getID(),

			onUpdate: self =>{
				//console.log( self );
				if ( self.progress > 0 ){
					if (  int.getBoundingClientRect().height <= 64.1  ){
						if (self.isActive) {
							this.body.classList.add( 'desktop-header-sticky' );
						}
						else{
							if ( self.progress < 1 ){
								this.body.classList.remove( 'desktop-header-sticky' );
							}
						}
					}
					else{
						this.body.classList.remove( 'desktop-header-sticky' );
					}
				}
				else{
					this.body.classList.remove( 'desktop-header-sticky' );
				}

			},

		});


		if ( this.body.classList.contains( 'home' ) ){
			gsap.to( int, {
				height: 64,
				scrollTrigger: {
					trigger: el,
					start: "top top+=20",
					end: '380px',
					scrub: true,
					markers: false,
					id: this.getID(),

				}
			});

			gsap.to( logo, {
				width: 280,
				scrollTrigger: {
					trigger: el,
					start: "top top+=20",
					end: '320px',
					scrub: true,
					markers: false,
					id: this.getID(),
				}
			});
		}
	}
	*/

	isMobile(){
		return this.window.innerWidth < 768;
	}

	isDesktop(){
		return this.window.innerWidth >= 1024;
	}

	isTablet(){
		return this.window.innerWidth > 767 && this.window.innerWidth < 1024;
	}

	/*
	checkMainWhenOverlapHeader(){
		const 	//h 	= document.querySelector('#header'),
				hm 	= document.querySelector('#header-mobile'),
				m  	= document.querySelector( '#main' );

		//if ( this.options.optimizeMobile && this.isMobile() ) return;

		if ( this.isTablet() && this.body.classList.contains( 'home' ) ) return;

		// desktop
		if ( this.isDesktop() ){
			ScrollTrigger.create({
				trigger: m,
				start: () => { return "top top+=" +  document.querySelector( '.header-desktop .layout' ).offsetHeight + "px"; }, // compact state of header desktop should be "top top+=64px"
				scrub: false,
				markers: false,
				id: this.getID(),
				onToggle: self => {
					if( self.isActive ){
						this.body.classList.add( 'desktop-header-overlap' );
					}
					else{
						this.body.classList.remove( 'desktop-header-overlap' );
					}
				}
			});
		}
		else{


			// mobile
			ScrollTrigger.create({
				trigger: m,
				start: "top top+=" + hm.offsetHeight, // header mobile height
				scrub: false,
				markers: false,
				id: this.getID(),
				onToggle: self => {
					if( self.isActive ){
						this.body.classList.add( 'mobile-header-overlap' );
					}
					else{
						this.body.classList.remove( 'mobile-header-overlap' );
					}
				}
			});
		}
	}
	*/


	initScrollText(){
		const el = document.querySelector( '.scroll-sidebar-effex' );
		if ( !el ) return;
		if ( this.options.optimizeMobile && this.isMobile() ) return;

		//return;

		const s = el.querySelector( '.sidebar .text' ), img = el.querySelector( '.image-content' );
		if ( s.offsetHeight > img.offsetHeight ) {
			const d = s.offsetHeight - img.offsetHeight,
				//y = 64 + parseInt( getComputedStyle( document.querySelector( '.wrap' ) )[ 'marginLeft' ] ); //el.getBoundingClientRect().top;
				y = el.getBoundingClientRect().top;


			gsap.to( s, {
				y: - d,
				//duration: 1,
				scrollTrigger:{
					trigger: el,
					start: "top top+=" + (y - 80) + "px", // header desktop compact + margin ( - 80 to allow see the dots for slideshow before lock )
					end: "+=" + d + 'px',
					scrub: true,
					markers: false,
					id: this.getID(),
					pin: el.parentNode,
					pinSpacing: false
				}
			});

		}
	}


	/*
	animateBackgroundGradient(){
		const el = this.body; ////document.querySelector( '#background' );
		if ( !el  ) return;
		// if ( this.options.optimizeMobile && this.isMobile() ) return;

		const animateColor = true;
		const l = Math.max( this.window.innerHeight/3 , this.getDocHeight() - this.getWindowHeight() );

		if ( animateColor ){

			const 	colorInit = getComputedStyle(document.documentElement).getPropertyValue('--color-gradient-top'),
					colorEnd = getComputedStyle(document.documentElement).getPropertyValue('--color-gradient-bottom');

			gsap.fromTo( document.documentElement,
				{	"--color-gradient-top": colorInit },
				{
					"--color-gradient-top": colorEnd,
					ease: "none",
					scrollTrigger: {
						trigger: el,
						markers: false,
						start: "top top",
						end: l,
						id: this.getID(),
						scrub: true,
					}
				}
			);

		}
	}
	*/


	/*
	lockTimelineSidebar() {
		const el = document.querySelector('aside .timeline-content');
		if (!el) return;

		// if element has an id, ensure we clear previous trigger
		if (el.id) this.killById(el.id);

		if (window.innerWidth > 767) {
			if (window.innerHeight < el.offsetHeight) return;

			const id = this.getID();
			el.id = id;

			const sidebar = document.querySelector('.sidebar-right');
			const sidebarTop = sidebar ? sidebar.getBoundingClientRect().top + window.pageYOffset : 0;
			const end = (sidebar ? sidebar.offsetHeight : 0) - (el.getBoundingClientRect().top + window.pageYOffset - sidebarTop) - el.offsetHeight;

			let p = document.querySelector('.module-sidebar-related-projects');
			let extra = p ? p.offsetHeight + 100 : 0;

			ScrollTrigger.create({
				trigger: el,
				pin: true,
				pinSpacing: false,
				start: 'top+=' + (el.offsetHeight / 2) + 'px center',
				end: '+=' + (end - extra),
				scrub: false,
				id: id
			});
		}
	}
	*/

	/*
	lockShareButtons() {
		const el = document.querySelector('.sidebar-left .module-share');
		if (!el) return;

		if (el.id) this.killById(el.id);

		if (window.innerWidth > 1023) {
			if (window.innerHeight < el.offsetHeight) return;

			const id = this.getID();
			el.id = id;

			const sidebar = document.querySelector('.sidebar-left');
			const sidebarTop = sidebar ? sidebar.getBoundingClientRect().top + window.pageYOffset : 0;
			const end = (sidebar ? sidebar.offsetHeight : 0) - (el.getBoundingClientRect().top + window.pageYOffset - sidebarTop) - el.offsetHeight;

			ScrollTrigger.create({
				trigger: el,
				pin: true,
				pinSpacing: false,
				start: 'top-=180px top',
				end: '+=' + end,
				scrub: false,
				id: id
			});
		}
	}
	*/

	initRecordMouseMovePosition(){
		document.addEventListener("mousemove", (e) => {
			this.mousePos.x = e.clientX;
			this.mousePos.y = e.clientY;
		});

	}

	initHeaderHide() {

		//if ( this.isDesktop() ) return;
		const 	el = document.querySelector('.main-content'),
				header = this.document.getElementById( 'header' );
		if (!el) return;


		ScrollTrigger.create({
			trigger: el,
			start: "top top",
			end: () => { return this.getDocHeight() - this.getWindowHeight(); },
			scrub: false,
			markers: false,
			id: this.getID(),

			onUpdate: self => {

				// show it if close to the end
				if ( self.progress > 0.98 ){
					this.body.classList.remove( 'hide-header' );
					return;
				}

				const y = self.scroll();
				const yback = header.offsetHeight;
				const direction = self.direction;
				let totalYback = yback;

				// if the mouse is close to the header
				if ( this.mousePos.y < yback + 100 ){
					this.body.classList.remove( 'hide-header' );
					return;
				}

				if (direction === 1) {
					if (y >= totalYback) {
						this.body.classList.add( 'hide-header' );
					}
					else{
						this.body.classList.remove( 'hide-header' );
					}
				} else if (direction === -1) {

					if ( y > totalYback ) this.body.classList.remove( 'hide-header' );
				}
			},

		});
	}


	/*
	setBurgerPin() {
		const el = document.querySelector('#burger');
		if (!el) return;

		ScrollTrigger.create({
			trigger: el,
			start: "top top+=10",
			pin: true,
			pinSpacing: false,
			end: () => { return this.getDocHeight() - this.getWindowHeight(); },
			scrub: true,
			markers: false,
			id: this.getID()
		});
	}
	*/

	/*
	setMobileHeaderPin() {
		const el = document.querySelector('#mobile-header');
		if (el && !this.body.classList.contains( 'home' )) {
			ScrollTrigger.create({
				trigger: el,
				start: "top top",
				pin: true,
				pinSpacing: false,
				end: () => { return this.getDocHeight() - this.getWindowHeight(); },
				scrub: true,
				markers: false,
				id: this.getID()
			});
		}
	}
	*/

	/*
	setBurgerMobilePin() {
		const el = document.querySelector('#burger-mobile');
		if (!el) return;
		ScrollTrigger.create({
			trigger: el,
			start: "top top+=5",
			pin: true,
			pinSpacing: false,
			end: () => { return this.getDocHeight() - this.getWindowHeight(); },
			scrub: true,
			markers: false,
			id: this.getID()
		});
	}
	*/

	/*
	setMenuSubPagesMobilePin() {
		const el = document.querySelector('#submenu-pages-mobile');
		if (!el) return;
		ScrollTrigger.create({
			trigger: el,
			start: "top top+=60",
			pin: true,
			pinSpacing: false,
			end: () => { return this.getDocHeight() - this.getWindowHeight(); },
			scrub: true,
			markers: false,
			id: this.getID()
		});
	}
	*/

	/*
	initMobileSubmenuPages() {
		const el = document.querySelector('.submenu-pages-mobile .scroll-layer');
		if (!el) return;

		// set width based on inner UL width + margin
		const inner = el.querySelector('ul');
		if (inner) el.style.width = Math.ceil(inner.scrollWidth + 70) + 'px';

		// draggable behaviour previously implemented with Draggable (GSAP). If you still use Draggable, re-enable here.
		// set current selection
		setTimeout(() => {
			const current = el.querySelector('li.current-menu-item');
			if (current) {
				const tox = Math.min(current.getBoundingClientRect().left - 20, el.scrollWidth - window.innerWidth);
				gsap.set(el, { x: -tox });
			}
		}, 200);
	}
	*/

	/*
	initSubmenuPages() {
		const el = document.querySelector('.submenu-pages-desktop');
		if (!el) return;

		const menu = el.querySelector('.menu.horizontal.nav-text');
		const sw = menu ? menu.scrollWidth : 0;
		const w = el.parentElement ? el.parentElement.clientWidth : 0;
		const n = el.parentElement ? (el.parentElement.querySelector('.name') ? el.parentElement.querySelector('.name').clientWidth : 0) : 0;
		let d = false;

		if (sw < w - n - 20) {
			el.style.width = 'auto';
		} else {
			el.style.width = (w - n - 20) + 'px';
			d = true;
		}

		el.style.paddingTop = (window.innerWidth <= 870 ? 3 : 7) + 'px';

		const dMenu = el.querySelector('.menu');
		if (d && dMenu) {
			dMenu.style.paddingRight = '70px';
			const shadow = el.querySelector('.shadow');
			if (shadow) shadow.style.opacity = '1';

			// Draggable usage would go here if needed; set current selection:
			setTimeout(() => {
				const c = dMenu.querySelector('li.current-menu-item');
				if (c) {
					const tox = Math.min(c.offsetLeft, dMenu.scrollWidth - el.clientWidth);
					gsap.set(dMenu, { x: -tox });
				}
			}, 0);
		} else if (dMenu) {
			dMenu.style.paddingRight = '0';
			const shadow = el.querySelector('.shadow');
			if (shadow) shadow.style.opacity = '0';
		}
	}
	*/

	/*
	initModuleHortFiltersSticky() {
		const el = document.querySelector('.module-hort-filters');
		if (!el) return;

		ScrollTrigger.create({
			trigger: el,
			start: "top top",
			pin: el,
			pinSpacing: false,
			end: () => { return this.getDocHeight() + 100 - this.getWindowHeight(); },
			scrub: true,
			markers: false,
			id: this.getID(),
			toggleClass: 'is-sticky',
			onToggle: self => {
				if (self.direction === 1) document.body.classList.add('is-anchor-menu-sticky');
				else document.body.classList.remove('is-anchor-menu-sticky');
			}
		});
	}
	*/

	/*
	initSubmenuSticky() {
		const el = document.querySelector('.submenu-pages nav.sticky');
		if (!el) return;

		this.body.classList.add( 'has-submenu-sticky' );

		ScrollTrigger.create({
			trigger: el,
			start: "top top",
			pin: el,
			pinSpacing: false,
			end: () => { return this.getDocHeight() - this.getWindowHeight(); },
			scrub: true,
			markers: false,
			id: this.getID(),
			onToggle: self => {
				if (self.isActive) this.body.classList.add( 'is-submenu-sticky' );
				else this.body.classList.remove( 'is-submenu-sticky' );
			}
		});
	}
	*/

	//-------------------------------------- UTILS -------------------------------//

	initEffectParallaxBackgroundImages() {


		const els = Array.from(document.querySelectorAll('.effect-parallax-background'));
		if (!els.length) return;
		if ( this.options.optimizeMobile && this.isMobile() ) return;

		els.forEach((el, i) => {

			let imgWrap = el.querySelector('.img-wrapper'),
				scale = _random( 1.17, 1.27 );

			let is_vertical = imgWrap.offsetHeight >= imgWrap.offsetWidth;

			gsap.set( imgWrap, {scale: scale,transformOrigin: 'center top' } );
			//gsap.set( imgWrap, {transformOrigin: 'center top'} );
			let y = Math.floor( el.offsetHeight - imgWrap.offsetHeight*scale ),
				x = Math.floor( (el.offsetWidth - imgWrap.offsetWidth*scale)/2 );

			gsap.to( imgWrap, {
				//y: is_vertical?y: 0,
				//x: is_vertical?0: x,
				y: y,
				ease: "none",
				scrollTrigger: {
					trigger: el,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
					markers: false,
					id: this.getID(),
					toggleClass: 'in-view'
				}
			});
		});

	}

	checkImagesInView() {
		const els = this.document.querySelectorAll( 'img' );
		if (!els.length) return;

		/*
		if ( this.options.optimizeMobile && this.isMobile() ){
			els.forEach(el => {
				el.classList.add( 'in-view' );
			});
			return;
		};
		*/

		els.forEach(el => {
			ScrollTrigger.create({
				trigger: el,
				start: "top bottom",
				end: "bottom top",
				scrub: true,
				markers: false,
				toggleClass: 'in-view',
				once: true
			});
		});
	}




	/*
	initInstagramParallax() {
		const els = Array.from(document.querySelectorAll('.instagram-gallery-item'));
		if (!els.length) return;
		if (window.innerWidth < 768 || this.htmlEl.classList.contains( 'touch' )) return;

		els.forEach((el, i) => {
			const pWrap = el.querySelector('.instagram-gallery-item__wrap');
			const p = pWrap ? parseInt(getComputedStyle(pWrap).marginTop) || 0 : 0;
			let v = _random(10, 20);
			let y = (i % 2 !== 0) ? v : -v;

			y = -p * 0.13;
			el.dataset.parallaxYp = y;

			gsap.to(el, {
				yPercent: y,
				ease: "none",
				scrollTrigger: {
					trigger: el,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
					markers: false,
					id: this.getID(),
					toggleClass: 'in-view'
				}
			});
		});
	}
	*/

	/*
	initParallaxWorks() {
		const grid = document.querySelector('.grid-works');
		if (!grid) return;
		if (window.innerWidth < 768 || this.htmlEl.classList.contains( 'touch' )) return;

		const items = grid.querySelectorAll('.item-grid');
		items.forEach((el, i) => {
			let v = _random(10, 20);
			let y = (i % 2 !== 0) ? v : -v;
			const p = el;
			y = -Math.random() * Math.min(70, p.clientWidth * 0.17);
			el.dataset.parallaxYp = y;

			const shake = p.querySelector('.shake');
			if (shake) {
				gsap.to(shake, {
					yPercent: y,
					ease: "none",
					scrollTrigger: {
						trigger: p,
						start: "top top+=" + parseInt((document.querySelector('#header') ? document.querySelector('#header').offsetHeight : 0)),
						end: "bottom top",
						scrub: true,
						markers: false,
						id: this.getID(),
						toggleClass: 'in-view'
					}
				});
			}
		});
	}
	*/

	/*
	initEffectParallaxImage() {
		const els = Array.from(document.querySelectorAll('.effect-parallax-image'));
		if (!els.length) return;
		if (window.innerWidth < 768 || this.htmlEl.classList.contains( 'touch' )) return;

		els.forEach(el => {
			const p = el.querySelector('.effect-parallax-image-container') || el.querySelector('.img-wrapper');
			const h = el.offsetHeight / 4;
			const o = el.querySelector('.overlay-bg');

			if (p) {
				gsap.to(p, {
					y: h,
					x: o ? '3%' : 0,
					ease: "none",
					scrollTrigger: {
						trigger: el,
						start: "top top",
						end: "bottom top",
						scrub: true,
						markers: false,
						id: this.getID()
					}
				});
			}

			if (o) {
				gsap.to(o, {
					x: '-120%',
					ease: "none",
					scrollTrigger: {
						trigger: el,
						start: "top top",
						end: "center top",
						scrub: true,
						markers: false,
						id: this.getID()
					}
				});

				const slideOverlay = el.querySelector('.slide-overlay');
				if (slideOverlay) {
					gsap.to(slideOverlay, {
						x: '-200%',
						opacity: 0,
						ease: "none",
						scrollTrigger: {
							trigger: el,
							start: "top top",
							end: "center top",
							scrub: true,
							markers: false,
							id: this.getID()
						}
					});
				}
			}
		});
	}
	*/


	initEffectParallaxImageSmoothTravelling() {
		const els = Array.from(document.querySelectorAll('.smooth-travelling'));
		if (!els.length) return;
		if (window.innerWidth < 768 || this.htmlEl.classList.contains( 'touch' )) return;

		els.forEach((el, i) => {
			let v = _random(6, 12);
			let y = _random(6) >= 4 ? v : -v;
			el.dataset.parallaxYp = y;

			gsap.to(el, {
				yPercent: y,
				ease: "none",
				scrollTrigger: {
					trigger: el,
					start: "top center",
					end: "bottom top",
					scrub: true,
					markers: false,
					id: this.getID()
				}
			});
		});
	}

	initEffectParallaxBeforeAfter() {
		const els = Array.from(document.querySelectorAll('.before-and-after .right'));
		if (!els.length) return;
		if (window.innerWidth < 768 || this.htmlEl.classList.contains( 'touch' )) return;

		els.forEach((el, i) => {
			let v = _random(10, 20);
			let y = -v; //_random(6) >= 4 ? v : -v;
			el.dataset.parallaxYp = y;

			gsap.to(el, {
				yPercent: y,
				ease: "none",
				scrollTrigger: {
					trigger: el,
					start: "top center",
					end: "bottom top",
					scrub: true,
					markers: false,
					id: this.getID()
				}
			});
		});
	}
	/*
	checkView() {
		const els = Array.from(document.querySelectorAll('.check-view'));
		if (!els.length) return;

		els.forEach(el => {
			ScrollTrigger.create({
				trigger: el,
				start: "top bottom",
				end: "bottom top",
				scrub: true,
				markers: false,
				toggleClass: 'in-view',
				once: true
			});
		});
	}
	*/

	/*
	initScrollColsAtDifferentSpeed() {
		const el = document.querySelector('#portfolio');
		if (!el) return;

		// reset the container to its height (if we reinit effect on Resize )
		el.style.height = 'auto';

		const c = document.querySelector('#col1');
		const c1 = document.querySelector('#col2');

		let col, colfix, h, h1, d;

		if ((c && c.querySelector('.inner') ? c.querySelector('.inner').offsetHeight : 0) > (c1 && c1.querySelector('.inner') ? c1.querySelector('.inner').offsetHeight : 0)) {
			col = c;
			colfix = c1;
		} else {
			col = c1;
			colfix = c;
		}

		if (!col || !colfix) return;

		h = col.querySelector('.inner').offsetHeight;
		h1 = colfix.querySelector('.inner').offsetHeight;
		d = h1 - h;

		gsap.killTweensOf(col);
		gsap.set(col, { y: 0 });

		gsap.to(col, {
			scrollTrigger: {
				trigger: col,
				start: "top top+=80px",
				end: "bottom bottom",
				toggleActions: "play none reverse none",
				scrub: true
			},
			y: d
		});

		el.style.height = h1 + 'px';
		el.style.overflow = 'hidden';

		const elsMobile = document.querySelector('#portfolio-mobile');
		if (elsMobile) {
			const items = elsMobile.querySelectorAll('.item-portfolio');
			items.forEach(item => {
				// Here "tap" was a touch plugin; using click as fallback
				this.off(item, 'tap'); // noop if not present
				this.on(item, 'click', (e) => {
					items.forEach(i => {
						if (i === e.currentTarget) i.classList.toggle('active');
						else i.classList.remove('active');
					});
				});
			});
		}
	}
	*/

	/*
	moveFooter(b) {
		if (this.htmlEl.classList.contains( 'mobile' ) || this.htmlEl.classList.contains( 'tablet' )) return;

		const target = document.querySelector('#footer .int');
		const trigger = document.querySelector('main');

		if (!target || !trigger) return;

		gsap.set(target, { y: 0, opacity: 1 });

		if (!b) return;

		gsap.from(target, {
			scrollTrigger: {
				trigger: trigger,
				start: "bottom bottom",
				end: "+=" + (target.offsetHeight),
				scrub: true,
				id: this.getID()
			},
			y: '40%',
			opacity: 0.9,
			ease: "none"
		});
	}
	*/

	//-------------------------------------------- UTILS ------------------------------//

	getID() {
		const id = 'id_' + this.ids.length;
		this.ids.push(id);
		return id;
	}

	killById(id) {
		if (ScrollTrigger.getById(id)) {
			ScrollTrigger.getById(id).kill();
		}
	}

	destroy() {
		this.addEvents(false);
		this.initProjectSingleShowTitleOnHeaderWhenScrolling( false );
		//this.moveFooter(false);
		//this.randomizeGradientHover( false );
		if (this.ids.length) {
			let i = this.ids.length;
			while (i--) {
				this.killById(this.ids[i]);
			}
			this.ids = [];
		}
	}

}
